<template>
  <div class="register-style">
    <h1 class="login-title">营口房地产交易服务平台</h1>
    <div class="form-style">
      <h2>用户注册</h2>
      <el-form
        ref="form"
        size="small"
        :model="form"
        :rules="rules"
        label-width="90px"
      >
        <el-form-item prop="userName" label="账号">
          <el-input v-model="form.userName" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item prop="passWord" label="密码" id="new_pwd">
          <el-input
            show-password
            v-model="form.passWord"
            type="password"
            placeholder="以字母开头，长度在6~18之间"
          id="new_pwd"></el-input>
        </el-form-item>
         <div class="mmqd">
            <span>(密码长度不低于6位数，包含大小写字母、数字和特殊符号)</span>
            <password-strength
              v-model="form.passWord"
            ></password-strength>
         </div>
        <el-form-item prop="spsd" label="确认密码">
          <el-input
            show-password
            v-model="form.spsd"
            type="password"
            placeholder="以字母开头，长度在6~18之间"
          ></el-input>
        </el-form-item>
        <el-form-item prop="realName" label="姓名">
          <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="idNumber" label="身份证号">
          <el-input
            placeholder="请输入身份证号"
            v-model="form.idNumber"
          ></el-input>
        </el-form-item> -->
        <el-form-item prop="phone" label="手机号">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <div class="yzm-style">
          <el-form-item prop="code" label="验证码">
            <el-input v-model="form.code"></el-input>
          </el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="getShortMessage"
            v-if="times == 0"
            >获取验证码</el-button
          >
          <el-button type="primary" v-else>{{ times }}s后重新发送</el-button>
        </div>
        <el-checkbox v-model="form.checked" prop="checked"></el-checkbox>
        <span class="agree-style"
          >本人承诺上述所填写的信息真实、准确，如有虚假，承担由此产生的一切法律责任。</span
        >
      </el-form>
      <div style="text-align: center; margin: 10px 0">
        <el-button style="width: 100%" type="primary" @click="register"
          >注册</el-button
        >
      </div>
      <div>
        <span class="login-btn">
          已有账号？
          <el-button size="small" type="text" @click="goLogin"
            >去登录</el-button
          >
        </span>
      </div>
    </div>
    <div class="foot-style">
      <div class="foot-cont">
        <div>
          <p>
            <span>电话：0417-3581115 / 0417-3851115</span>
            <span>地址：新联北大街99号</span>
            <span>邮箱：ykdcxxkj@163.com</span>
          </p>
          <p class="xx-bottom">
            <span> 服务支持单位：营口市自然资源事务中心</span>
            <span>主办单位：营口大成信息科技咨询有限公司</span>
            <span>技术支持：营口大成信息科技咨询有限公司</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordStrength from "@/components/PasswordStrength";
export default {
  data() {
    const validatePassword = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入密码'));
        } else {
            //6-20位包含字符、数字和特殊字符
            var ls = 0;
            if (this.form.passWord !== '') {
                if(this.form.passWord.match(/([a-z])+/)){
                    ls++;
                }
                if(this.form.passWord.match(/([0-9])+/)){
                    ls++;
                }
                if(this.form.passWord.match(/([A-Z])+/)){
                    ls++;
                }
            if(this.form.passWord.match(/([\W])+/) && !this.form.passWord.match(/(![\u4E00-\u9FA5])+/)){                            ls++;
                }
                if(this.form.passWord.length<6 || this.form.passWord.length>20 ){
                    callback(new Error('要求6-20位字符'));
                    ls=0;
                }
                if(this.form.passWord.match(/([\u4E00-\u9FA5])+/)){
                    callback(new Error('不能包含中文字符'));
                    ls=0;
                }
                switch (ls) {
                    case 0: this.passwordPercent = 0;callback(new Error('数字、小写字母、大写字母以及特殊字符中四选三'));break;
                    case 1: this.passwordPercent = 33;callback(new Error('数字、小写字母、大写字母以及特殊字符中四选三'));break;
                    case 2: this.passwordPercent = 66;callback(new Error('数字、小写字母   、大写字母以及特殊字符中四选三'));break;
                    case 3:
                    case 4: this.passwordPercent = 100;break;
                    default: this.passwordPercent = 0;break;
                }
            }
            callback();
        }
    };
    const checkSpd = (rule, value, callback) => {
      var data = value + "";
      if (!data) {
        callback(new Error("确认密码不能为空"));
      } else if (data != this.form.passWord) {
        callback(new Error("两次密码不一致，请输入输入！"));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      let regPone = null;
      let mobile = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/; // 最新16手机正则
      // let tel = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/; // 座机
      let data = value + "";
      // if (data !== null && data.charAt(0) === "0") {
      //   // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
      //   regPone = tel;
      // } else if (data !== null && data.charAt(0) !== "0") {
      //   regPone = mobile;
      // }
      regPone = mobile;
      if (regPone === null) {
        return callback(new Error("请输入手机号码"));
      } else if (!regPone.test(data)) {
        return callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    const checkIdentitytionId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      }
      if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        callback(new Error("你输入的身份证长度或格式错误"));
      }
      //身份证城市
      var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外",
      };
      if (!aCity[parseInt(value.substr(0, 2))]) {
        callback(new Error("你的身份证地区非法"));
      }
      // 出生日期验证
      var sBirthday = (
          value.substr(6, 4) +
          "-" +
          Number(value.substr(10, 2)) +
          "-" +
          Number(value.substr(12, 2))
        ).replace(/-/g, "/"),
        d = new Date(sBirthday);
      if (
        sBirthday !=
        d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
      ) {
        callback(new Error("身份证上的出生日期非法"));
      }

      // 身份证号码校验
      var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
      for (var i = 0; i < value.length - 1; i++) {
        sum += value[i] * weights[i];
      }
      var last = codes[sum % 11]; //计算出来的最后一位身份证号码
      if (value[value.length - 1] != last) {
        callback(new Error("你输入的身份证号非法"));
      }
      callback();
    };
    return {
      passwordPercent:0,
      formLabelWidth: '120px',

      checked: false,
      form: {
        phone: "",
        userName: "",
        realName: "",
        passWord: "",
        spsd: "",
        code: "",
        unitId: 4,
        unitName: "个人用户",
        idNumber: "",
        checked: false,
      },
      verifCode: "", //后端返回的短信验证码
      rules: {
        userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        passWord: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码不得低于6个字符", trigger: "blur" },
          // {required: true, validator: validatePassword, trigger: ['blur', 'change'] },
        ],
        spsd: [
          { required: true, validator: checkSpd, trigger: "blur" },
          { min: 6, message: "密码不得低于6个字符", trigger: "blur" },
        ],
        // idNumber: [
        //   { required: true, validator: checkIdentitytionId, trigger: "blur" },
        // ],
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        code: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
      },
      times: 0,
    };
  },
  components: { PasswordStrength },
  methods: {
    passwordPercentFormat(percentage){
      return percentage === 100 ? '符合' : `不符`;
    },
    getTime() {
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    getShortMessage() {
      //判断手机号是否录入
      if (this.verifPhone(this.form.phone)) {
        var that = this;
        that
          .axios({
            method: "post",
            url: "/api/shortMessage/getCode",
            data: {
              phone: that.form.phone,
            },
          })
          .then((res) => {
            if (res.data == "当日发送已达上限") {
              that.$message.error(res.data);
            } else {
              that.times = 60;
              that.getTime();
            }
          });
      } else {
        this.$message.error("请输入正确的手机号码");
      }
    },
    //验证手机号码是否合格
    verifPhone(phone) {
      let mobile = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/; // 最新16手机正则
      // let mobile=/^1[1356789]\d{9}$/;
      if (phone === null) {
        return false;
      } else if (!mobile.test(phone)) {
        return false;
      }
      return true;
    },
    //注册
    register() {
      if (this.form.checked) {
        var that = this;
        console.log(that.form);
        that.$refs.form.validate((valid) => {
          if (valid) {
            that
              .axios({
                method: "post",
                url: "/api/grzl/register",
                data: that.form,
              })
              .then((res) => {
                if (res.data === "注册成功") {
                  that.$message.success(res.data);
                  // that.$router.push("/login");
                  //走登录方法，进行登录
                  that.form.user = this.form.userName;
                  that.form.psd = that.form.passWord;
                  that
                    .axios({
                      method: "post",
                      url: "/api/login/login.do",
                      data: that.form,
                    })
                    .then(function (res) {
                      console.log(res.data);
                      if (res.data.status == 200) {
                        localStorage.setItem("userId", res.data.data.userId);
                        localStorage.setItem(
                          "userName",
                          res.data.data.userName
                        );
                        res.data.data.type = that.form.type;
                        that.$store.commit("setUserData", res.data.data);
                        that.$router.push("/");
                        // that.$message.success(res.data.msg);
                      } else {
                        that.$message.error(res.data.msg);
                      }
                    });
                } else {
                  that.$message.error(res.data);
                }
              });
          }
        });
      } else {
        this.$alert("请勾选下方同意按钮方可进行注册", "", {
          confirmButtonText: "确定",
          type: "warning",
        });
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less">
// .el-form-item{
//     width: 400px;
// }

.register-style {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url("../assets/login_bg1.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  .login-title {
    color: #fff;
    margin: 40px 0 0 60px;
    font-size: 34px;
    font-weight: normal;
  }
  .form-style {
    right: 110px;
    padding: 20px 60px;
    width: 468px;
    // height: 560px;
    background-color: rgba(255, 255, 255, 0.6) !important;
    border-radius: 10px;
    color: #5d5d5d;
    position: absolute;
    top: 40% !important;
    transform: translateY(-50%);
    h2 {
      text-align: center;
      margin-bottom: 10px !important;
      font-size: 20px;
    }
    .el-form-item {
      border: 1px solid #c9cacc;
      background: #fff;
      padding-left: 12px;
      margin-bottom: 10px !important;
      border-radius: 4px;
      .el-form-item__content,
      .el-form-item__label {
        height: 28px;
        line-height: 28px;
      }
      .el-input__inner {
        border: 0;
        height: 28px;
        line-height: 28px;
        border-radius: 0;
      }
      .el-form-item__label {
        display: inline-block;
        text-align: justify;
        text-align-last: justify;
        font-size: 14px;
      }
    }
    .yzm-style {
      display: flex;
      justify-content: space-between;
      text-align: center;
      margin-bottom: 10px;
      .el-button {
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        // border: 1px soild #409EFF;
        margin-left: -5px;
        z-index: 100;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      .el-form-item {
        width: 300px;
        margin-bottom: 0;
      }
    }
    .login-btn {
      font-size: #999;
      margin-left: 28px;
      font-size: 12px;
    }
    .agree-style {
      font-size: 12px;
    }
  }
  .foot-style {
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 20px 0;
    .foot-cont {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      font-size: 12px;
      line-height: 30px;
      span {
        margin-right: 10px;
      }
    }
  }
  .mmqd{
    text-align: center;
    font-size: 14px;
    background: #fff;
    padding: 5px 0;
    margin-bottom: 10px;
    >span{
      font-size: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Register.vue